/** Partner admin: amounts stored in USD; INR shown for RazorpayX transfer. */

export function formatUSD(n) {
  return `$${Number(n || 0).toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
}

export function formatINR(n) {
  return `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

/** USD primary with optional INR line (from API payout_amount_fields). */
export function formatUsdWithInr(usd, inr) {
  if (inr == null || Number.isNaN(Number(inr))) {
    return formatUSD(usd);
  }
  return `${formatUSD(usd)} (${formatINR(inr)} at payout)`;
}
